<template lang="pug">
div.form-inline.align-items-center
  label.mx-1
    | {{ t('anyo') }}:
  select.form-control.mx-1(v-model="selectedYear" data-cy="year_selector")
    option(v-for="option in years" :key="`years_${option}`" :value="option")
      | {{ option }}
  label.mx-1
    | {{ t('mes') }}:
  select.form-control.mx-1(v-model="selectedMonth" data-cy="month_selector")
    option(v-for="option in months" :key="`months_${option}`" :value="option")
      | {{ monthName(option) }}

</template>

<script>
import customVmodel from 'common/mixins/custom_vmodel'
import mixins from 'common/mixins'

export default {
  name: 'year-month-selector-vue',
  mixins: [customVmodel, mixins.translate],
  props: {
    first: { type: String, default: '' },
    last: { type: String, default: '' }
  },
  data () {
    return {
      selectedYear: this.getYear(this.value || this.last),
      selectedMonth: this.getMonth(this.value || this.last),
      localValue: this.value || this.last
    }
  },
  methods: {
    getMonth(data) {
      return parseInt(data.split('-')[1])
    },
    getYear(data) {
      return parseInt(data.split('-')[0])
    },
    formatKey(year, month) {
      return `${year}-${this.formatMonth(month)}`
    },
    formatMonth(month) {
      return String(month).padStart(2, '0')
    },
    monthName(month) {
      return (new Date(new Date().getFullYear(), month - 1))
        .toLocaleString(gon.iso_language, { month: 'long' })
    }
  },
  computed: {
    firstYear() { return this.getYear(this.first) },
    firstMonth() { return this.getMonth(this.first) },
    lastYear() { return this.getYear(this.last) },
    lastMonth() { return this.getMonth(this.last) },
    months() {
      let first = this.selectedYear == this.firstYear ? this.firstMonth : 1
      let last = this.selectedYear == this.lastYear ? this.lastMonth : 12

      return Array.from(
        { length: last - first + 1 },
        (_value, index) => first + index
      )
    },
    years() {
      return Array.from(
        { length: (this.lastYear - this.firstYear + 1) },
        (_value, index) => this.firstYear + index
      )
    }
  },
  watch: {
    value (value) {
      this.localValue = value
      this.selectedYear = this.getYear(value)
      this.selectedMonth = this.getMonth(value)
    },
    selectedYear(value) {
      if (this.firstYear == value && this.selectedMonth < this.firstMonth)
        this.selectedMonth = this.firstMonth
      if (this.lastYear == value && this.selectedMonth > this.lastMonth)
        this.selectedMonth = this.lastMonth
      this.localValue = this.formatKey(value, this.selectedMonth)
    },
    selectedMonth(value) {
      this.localValue = this.formatKey(this.selectedYear, value)
    }
  }
}
</script>
